const toRendaNumber = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

// Renda considerada para a parcela ideal: renda mensal + renda extra/familiar
const getRendaQualificada = ({ rendaMensal, rendaExtra } = {}) =>
  toRendaNumber(rendaMensal) + toRendaNumber(rendaExtra);

export default getRendaQualificada;
